import { Box, Stack } from '@ace-clublabs/shared-component-library';
import { BenefitCompareChart, SelectMembershipDisclaimer } from '../SelectMembership';
import { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../state/state';

export const SelectMembershipSection: React.FC = () => {
  const boxRef = useRef<HTMLElement>(null);
  const [boxHeight, setBoxHeight] = useState('auto');
  const [formData] = useGlobalState('formData');

  const updateBoxHeight = () => {
    if (boxRef.current) {
      const height = boxRef.current.offsetHeight; // Measure the height of the box
      setBoxHeight(`${height}px`); // Set the box background height to the size of the container
    }
  };

  useEffect(() => {
    updateBoxHeight();

    window.addEventListener('resize', updateBoxHeight);

    return () => {
      window.removeEventListener('resize', updateBoxHeight);
    };
  }, []);

  // update box height when membership selection changes to match different additional benefit content heights
  useEffect(() => {
    updateBoxHeight();
  }, [formData?.requestedMembershipLevel]);

  return (
    <Stack
      className="select-membership-section-stack"
      sx={{
        marginTop: '1.5rem',
        width: '100%',
      }}
      alignItems={'center'}
    >
      <Box
        className="background-box"
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          backgroundColor: '#FAF8F4',
          zIndex: -1,
          width: '100vw',
          height: boxHeight,
        }}
      />
      <Box ref={boxRef} display="flex" flexDirection="column" alignItems="center" width="100%">
        <BenefitCompareChart />
      </Box>
      <SelectMembershipDisclaimer />
    </Stack>
  );
};
